import React from 'react';
import { IconPlus } from '../icons';

// No chip strip and no "who can afford this" roster here. The strip means one
// thing in this world — which child a box belongs to — and a reward belongs to
// nobody. A roster also ranks the children publicly: the child with the fewest
// tokens would be absent from every row. A child's own distance to a reward is
// personal, so it lives in their own Spend tab instead.
export default function RewardsView({ spendingChoices, onGoAdmin, headingRef }) {
  const cheapest = spendingChoices.reduce(
    (low, c) => (!low || c.price < low.price ? c : low), null
  );

  return (
    <div className="rewards-view">
      <header className="page-head">
        <h1 tabIndex={-1} ref={headingRef}>The Shelf</h1>
        <p>
          Everything tokens can buy, and what each one costs. Open your box on the
          board to spend.
        </p>
      </header>

      {spendingChoices.length === 0 ? (
        <div className="empty">
          <h2>Nothing on the shelf</h2>
          <p>
            No rewards yet. A grown-up can put the first one up, give it a price in
            tokens, and it appears here.
          </p>
          <button type="button" className="btn btn--primary" onClick={onGoAdmin}>
            <IconPlus />
            Add the first reward
          </button>
        </div>
      ) : (
        <>
          <ul className="wall">
            {spendingChoices.map(choice => (
              <li key={choice.id}>
                <article className="box box--static box--reward">
                  <div className="box-body">
                    <h2 className="box-name">{choice.name}</h2>
                    {choice.description && (
                      <p className="box-desc">{choice.description}</p>
                    )}
                    <hr className="box-rule" />
                    <p className="box-figure">
                      <span className="fig">{choice.price}</span>
                      <span className="unit">
                        {choice.price === 1 ? 'Token' : 'Tokens'}
                      </span>
                    </p>
                  </div>
                </article>
              </li>
            ))}
          </ul>

          <dl className="ledger">
            <div className="ledger-cell">
              <dt>On the shelf</dt>
              <dd>{spendingChoices.length}</dd>
            </div>
            <div className="ledger-cell">
              <dt>Cheapest</dt>
              <dd>
                {cheapest.price}
                <small>{cheapest.name}</small>
              </dd>
            </div>
          </dl>
        </>
      )}
    </div>
  );
}
